export default __webpack_public_path__ + "static/stack-usage-example-bd6083e6335ec82c8983489abc34eb1929a21955e005bf76202266efd9814005.png";